module.exports = __webpack_public_path__ + "media/images/rocket-1ec448653eeeaf47143d242d32678155.svg";